
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit: function (e, page) {
      const app = this.$app;
      const $$ = this.$;
      var $page = $$(page.el);
      var doc = this.$route.params.doc;
      const couponApplyAfter = [];
      $page.on('click', '.couponApply', function (e) {
        var couponCode = $$(this).data('code');
        $$('#couponApplyForm input[name="applyedCouponCode"]').val(couponCode);
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'coupons/validate',
          method: 'POST',
          data: JSON.stringify({
            coupon_code: couponCode,
            doctor_id: doc
          }),
          contentType: 'application/json',
          dataType: 'json',
          success: function (data) {
            app.preloader.hide();
            console.log(data);
            if (data.status) {
              if (data.data.isValid) {
                console.log('valid coupon');
                $$('#bookingCoupon').val(data.data.coupon);
                $$('#couponApplyBefor').hide();
                $$('#couponApplyAfter').show();
                $$('#couponApplyAfter .couponName').text(couponCode);
                $$('#couponApplyAfter .couponValueAmount').text(data.data.discountAmount);
                couponApplyAfter.dscnt_amt = $$('#amntdetail .dscnt_amt').text();
                couponApplyAfter.gstAmount = $$('#amntdetail .gstAmount').text();
                couponApplyAfter.totalAmnt = $$('#amntdetail .totalAmnt').text();
                $$('#amntdetail .dscnt_amt').text(data.data.discountAmount);
                $$('#amntdetail .gstAmount').text(data.data.gstAmount);
                $$('#amntdetail .totalAmnt').text(data.data.TotalCharge);
                app.views.main.router.back();
              } else {
                invalidErrorShow();
                console.log('not valid coupon');
              }
            } else {
              invalidErrorShow();
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      $page.on('click', '.applyingCoupon', function (e) {
        var couponCode = $$('#couponApplyForm input[name="applyedCouponCode"]').val();
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'coupons/validate',
          method: 'POST',
          data: JSON.stringify({
            coupon_code: couponCode,
            doctor_id: doc
          }),
          contentType: 'application/json',
          dataType: 'json',
          success: function (data) {
            app.preloader.hide();
            console.log(data);
            if (data.status) {
              if (data.data.isValid) {
                console.log('valid coupon');
                $$('#bookingCoupon').val(data.data.coupon);
                $$('#couponApplyBefor').hide();
                $$('#couponApplyAfter').show();
                $$('#couponApplyAfter .couponName').text(couponCode);
                $$('#couponApplyAfter .couponValueAmount').text(data.data.discountAmount);
                couponApplyAfter.dscnt_amt = $$('#amntdetail .dscnt_amt').text();
                couponApplyAfter.gstAmount = $$('#amntdetail .gstAmount').text();
                couponApplyAfter.totalAmnt = $$('#amntdetail .totalAmnt').text();
                $$('#amntdetail .dscnt_amt').text(data.data.discountAmount);
                $$('#amntdetail .gstAmount').text(data.data.gstAmount);
                $$('#amntdetail .totalAmnt').text(data.data.TotalCharge);
                app.views.main.router.back();
              } else {
                invalidErrorShow();
                console.log('not valid coupon');
              }
            } else {
              invalidErrorShow();
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      function invalidErrorShow() {
        $$('#couponApplyForm .coupon-entry-error').show();
      }
      $page.on('blur', '#couponApplyForm input[name="applyedCouponCode"]', function (e) {
        console.log('error hatao ');
        $$('#couponApplyForm .coupon-entry-error').hide();
      });
      $page.on('submit', '#couponApplyForm_', function (e) {
        e.preventDefault();
        console.log('coupon form submit');
        var token = localStorage.getItem('token');
      });
    }
  },
  id: '44e2643e99',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page apply-coupon-page" data-name="apply_coupon">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Apply Coupon</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="coupon-entry">\n                <div class="coupon-entry-label">Have a coupon code?</div>\n                <form id="couponApplyForm">\n                    <div class="coupon-entry-row">\n                        <input class="upper_case coupon-entry-input" name="applyedCouponCode" type="text" placeholder="Enter code" required validate data-error-message="Please enter valid coupon !!">\n                        <a href="#" class="popup-close">\n                            <button type="submit" class="coupon-entry-btn applyingCoupon">Apply</button>\n                        </a>\n                    </div>\n                    <div class="coupon-entry-error" style="display: none">Please enter a valid coupon code.</div>\n                </form>\n            </div>\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="coupon-section-title">Available coupons</div>\n            <div class="coupon-list">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="coupon-card">\n                    <div class="coupon-card-stub">\n                        <i class="icon f7-icons if-not-md">tag_fill</i>\n                        <i class="icon material-icons md-only">local_offer</i>\n                    </div>\n                    <div class="coupon-card-body">\n                        <div class="coupon-card-code couponCode">';
              r += c(ctx_3.code, ctx_3);
              r += '</div>\n                        <div class="coupon-card-desc">';
              r += c(ctx_3.description, ctx_3);
              r += '</div>\n                    </div>\n                    <button class="coupon-card-copy couponApply" data-code="';
              r += c(ctx_3.code, ctx_3);
              r += '">\n                        <i class="icon f7-icons if-not-md">checkmark_alt</i>\n                        <i class="icon material-icons md-only">check</i>\n                        <span>Apply</span>\n                    </button>\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/no_coupon.svg" alt="">\n                <div class="empty-state-title">No coupons available</div>\n                <div class="empty-state-sub">You can still enter a code above if you have one.</div>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    